import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationContainerDirective } from './shared/directives/notification-container.directive';
import { DropdownOverlayDirective } from './shared/directives/dropdown-overlay.directive';
import { ModalContainerDirective } from './core/directives/modal-container.directive';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NotificationContainerDirective, DropdownOverlayDirective, ModalContainerDirective],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'TaxTimer';

  public throwTestError(): void {
    throw new Error('Sentry Test Error');
  }
}
